import { useState } from 'react';

const N8N_WEBHOOK_URL = "https://automations.tonalida.com.br/webhook/d522d81d-2c72-4efd-8623-4118b15e7542";

const useEnterpriseContact = () => {
    const [formData, setFormData] = useState({
        companyName: '',
        phone: '',
        jobCount: ''
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!N8N_WEBHOOK_URL) {
            setError("Webhook URL não configurada.");
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await fetch(N8N_WEBHOOK_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error('Falha no envio.');
            }

            setSuccess(true);
            setFormData({
                companyName: '',
                phone: '',
                jobCount: ''
            });

            setTimeout(() => setSuccess(false), 5000);

        } catch (err) {
            console.error(err);
            setError("Ocorreu um erro ao enviar. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return {
        formData,
        handleChange,
        handleSubmit,
        loading,
        success,
        error
    };
};

export default useEnterpriseContact;
